export const optionsInputForModalWindow = {
  surname: {
    key: "surname",
    label: "Фамилия",
    type: "text",
    required: true,
    disabled: false,
    upperCase: true,
  },
  name: {
    key: "name",
    label: "Имя",
    type: "text",
    required: true,
    disabled: false,
    upperCase: true,
  },
  midname: {
    key: "midname",
    label: "Отчество",
    type: "text",
    required: false,
    disabled: false,
    upperCase: true,
  },
  persNum: {
    key: "persNum",
    label: "Идентификационный номер",
    type: "text",
    required: false,
    disabled: false,
    upperCase: true,
    pattern: {
      value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
      message: `Введите номер латинскими в формате "0000000A000AA0"`,
    },
  },
  birthDate: {
    key: "birthDate",
    label: "Дата рождения",
    type: "date",
    required: true,
    disabled: false,
    customValidation: (value, data) => {
      if (data.trainingDocumentsDateStart) {
        if (isEighteenYearsBetween(value, data.trainingDocumentsDateStart)) return true;
        return "Возраст - не менее 18 лет на дату начала обучения";
      }
    },
  },
  birthPlace: {
    key: "birthPlace",
    label: "Место рождения",
    type: "selectWithSearch",
    required: false,
    disabled: false,
    searchable: true,
    options: [],
  },
  trainingDocumentsDateStart: {
    key: "trainingDocumentsDateStart",
    label: "Период обучения с",
    type: "date",
    required: true,
    disabled: false,
    customValidation: (value, data, setError, clearErrors) => {
      let error = "";
      if (data.birthDate) {
        if (isEighteenYearsBetween(data.birthDate, value)) {
          clearErrors("birthDate");
        } else {
          setError("birthDate", {
            type: "custom",
            message: "Возраст - не менее 18 лет на дату рождения",
          });
        }
      }
      if (new Date() < new Date(value)) {
        error = "“Период с” - не позже текущей даты";
      }
      return error || true;
    },
  },
  trainingDocumentsDateEnd: {
    key: "trainingDocumentsDateEnd",
    label: "Период обучения по",
    type: "date",
    required: true,
    disabled: false,
    customValidation: (value, data, setError, clearErrors) => {
      let error = "";
      if (data.trainingDocumentDocDate) {
        if (new Date(data.trainingDocumentDocDate) >= new Date(value)) {
          clearErrors("trainingDocumentDocDate");
        } else {
          setError("trainingDocumentDocDate", {
            type: "custom",
            message: "Валидация - дата равна или позже даты окончания обучения",
          });
        }
      }
      if (data.trainingDocumentsDateStart) {
        if (new Date(data.trainingDocumentsDateStart) > new Date(value)) {
          error = "“Период по” - не позже даты начала обучения";
        }
      }
      if (new Date() < new Date(value)) {
        error = "“Период по” - не позже текущей даты";
      }
      return error || true;
    },
  },
  trainingDocumentsDocTypeId: {
    key: "trainingDocumentsDocTypeId",
    label: "Вид",
    type: "selectWithSearch",
    required: true,
    disabled: false,
    searchable: false,
    options: [],
  },
  trainigDocumentDocNum: {
    key: "trainigDocumentDocNum",
    label: "Серия, номер",
    type: "text",
    required: true,
    disabled: false,
    upperCase: true,
  },
  trainingDocumentDocDate: {
    key: "trainingDocumentDocDate",
    label: "Дата документа об образовании",
    type: "date",
    required: true,
    disabled: false,
    customValidation: (value, data) => {
      let error = "";

      if (data.trainingDocumentsDateEnd) {
        if (new Date(value) < new Date(data.trainingDocumentsDateEnd)) {
          error = "Валидация - дата равна или позже даты окончания обучения";
        }
      }
      if (new Date(value) >= new Date()) {
        error = "Валидация - дата не может быть позднее текущей";
      }

      return error || true;
    },
  },
  address: {
    key: "address",
    label: "Адрес места жительства",
    type: "text",
    textArea: "textarea",
    disabled: false,
    required: false,
    upperCase: true,
  },
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    required: false,
    disabled: false,
    pattern: {
      value: /^[0-9+\s,;()-]*$/,
      message: `Недоспустимые символы: введите цифры, (), -, +`,
    },
  },
};
export function isEighteenYearsBetween(date1, date2) {
  // Преобразуем строки дат в объекты Date
  let startDate = new Date(date1);
  let endDate = new Date(date2);

  // Проверяем, что обе даты валидны
  if (isNaN(startDate) || isNaN(endDate)) {
    return false;
  }

  // Вычисляем разницу в годах
  let yearsDifference = endDate.getFullYear() - startDate.getFullYear();

  // Проверяем, если между датами ровно 18 лет или больше
  if (yearsDifference > 18) {
    return true;
  } else if (yearsDifference < 18) {
    return false;
  } else {
    // Если разница в годах ровно 18, проверяем месяцы и дни
    let monthDifference = endDate.getMonth() - startDate.getMonth();
    if (monthDifference > 0) {
      return true;
    } else if (monthDifference < 0) {
      return false;
    } else {
      // Если разница в месяцах нулевая, проверяем дни
      return endDate.getDate() >= startDate.getDate();
    }
  }
}
export const captionsForModalWindow = {
  add: "Добавить прошедшего обучение",
  edit: "Редактировать данные",
};
export const setOptionsForModalWindowTrainedUser = (type, props) => {
  switch (type) {
    case "firstInit": {
      optionsInputForModalWindow.trainingDocumentsDocTypeId.options = props.trainingDocTypes;
      optionsInputForModalWindow.birthPlace.options = props.countries;
      const disabledInputs = [
        "surname",
        "name",
        "midname",
        "birthDate",
        "trainingDocumentsDateStart",
        "trainingDocumentsDateEnd",
        "trainingDocumentsDocTypeId",
        "trainigDocumentDocNum",
        "trainingDocumentDocDate",
      ];
      disabledInputs.forEach((key) => (optionsInputForModalWindow[key].disabled = false));
      break;
    }
  }
};
export const setOptionsModalWindowDisabledInputs = () => {
  const disabledInputs = [
    "surname",
    "name",
    "midname",
    "birthDate",
    "trainingDocumentsDateStart",
    "trainingDocumentsDateEnd",
    "trainingDocumentsDocTypeId",
    "trainigDocumentDocNum",
    "trainingDocumentDocDate",
  ];
  disabledInputs.forEach((key) => (optionsInputForModalWindow[key].disabled = true));
};
export const getOptionsForModalWindowTrainedUser = () => optionsInputForModalWindow;
